import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { LucideSearch } from '@lucide/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'ptl-search',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslocoModule],
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent {
  value = input('');
  placeholder = input<string | undefined>(undefined);
  disabled = input(false);
  valueChange = output<string>();

  protected focused = signal(false);
  protected readonly LucideSearch = LucideSearch;

  onInput(event: Event): void {
    this.valueChange.emit((event.target as HTMLInputElement).value);
  }
}
